import { render, staticRenderFns } from "./JcdcRatingsKey.vue?vue&type=template&id=78a6146a"
import script from "./JcdcRatingsKey.vue?vue&type=script&lang=ts"
export * from "./JcdcRatingsKey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports